












































import {
  Component, mapState, Watch, mixins,
} from '@samclick-commons';
import SamclickMixins from '@/utils/mixins';
import {
  CampaignStore, Payload, AuthorizationStore, CommonsStore,
} from '@samclick-store-factory';
import { _isEmpty } from '@samclick-lodash';

class FormData {
    id: number | string = ''

    name: string = ''

    status: number = 1

    groupID: number | string = ''

    advertisementCategoryId: string | number = 1
}

class AddCampaignState {
        showDialog: boolean = false

      action: string = 'add'

       formData = new FormData()
}

    @Component({
      /**
         * Imported components
         * */
      components: {},
      /**
         * Stores values
         * */
      computed: {
        ...mapState({
          campaignStatus: (state: any) => state.commons.commonsStore.campaignStatus,
          campaignGroup: (state: any) => state.commons.commonsStore.campaignGroup,
        }),
      },
      /**
         * Component properties
         * */
      props: {},
    })
export default class AddCampaign extends mixins(SamclickMixins) {
        /**
         * Local state
         * */
        state = new AddCampaignState();

        rules = {
          advertisementCategoryId: [
            { required: true, message: 'Please select category', trigger: 'blur' },
          ],
        }

        /**
         * Watchers
         * */
        @Watch('state.showDialog')
        dialogWatcher(newVal: string, oldVal: string) {
          if (oldVal && !newVal) {
            this.state = new AddCampaignState();
          }
        }

        @Watch('ifLocaleChange', { immediate: true })
        localeChanges() {
          this.rules = {
            name: [
              { required: true, message: this.$t('campaign.err_name'), trigger: 'blur' },
            ],
          };
        }

        /**
         * Methods
         * */
        toggleDialog(show: false, editRow: object = {}) {
          this.state.showDialog = show;

          if (!_isEmpty(editRow)) {
            const formData = new FormData();
            formData.id = editRow.id;
            formData.name = editRow.name;
            formData.advertisementCategoryId = editRow.advertisementCategoryId;
            formData.status = editRow.status;
            formData.groupID = editRow.groupId > 0 ? editRow.groupId : '';
            this.state.formData = formData;
            this.state.action = 'edit';
          }
        }

        saveCampaign() {
          this.$refs.campaignForm.validate((valid) => {
            if (valid) {
              this.showAlert(this.$t('api_error.prompt_saving').toString(), this.$data.SamclickAlert.WARNING, true).then(() => {
                const {
                  name, groupID, advertisementCategoryId, status, id,
                } = this.state.formData;

                CampaignStore.saveCampaign(new Payload({
                  affiliateId: AuthorizationStore.currentLoggedUserInState.id,
                  name,
                  groupId: groupID,
                  advertisementCategoryId,
                  status,
                  id,
                })).then((response) => {
                  this.showSuccessAlert();
                  this.toggleDialog(false);
                  this.emitEventHandler('reload');
                }, (error) => {
                  if (error.status === 409) {
                    this.showAlert(this.$t('api_error.campaign_exist').toString(), this.$data.SamclickAlert.ERROR);
                  }
                });
              }).catch(() => {});
            }
          });
        }


        /**
         * Computed
         * */
        get activeCampaignGroup() {
          return CommonsStore.activeCampaign;
        }

        get advertisementCategories() {
          return CommonsStore.allAdvertisementCategories;
        }

        getAdvertisementCategoryName(advertisementCategoryId: number) {
          return CommonsStore.advertisementCategoryName(advertisementCategoryId);
        }

        /**
         * Lifecycle hooks
         * */
        created() {
        }

        mounted() {
        }

        beforeUpdate() {

        }
}
